import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'monthname'
})
export class MonthNamePipe implements PipeTransform  {

  transform(value: number): string {
    let result = '';
    switch (value) {
      case 1:
        result = 'Januar';
        break;
      case 2:
        result = 'Februar';
        break;
      case 3:
        result = 'März';
        break;
      case 4:
        result = 'April';
        break;
      case 5:
        result = 'Mai';
        break;
      case 6:
        result = 'Juni';
        break;
      case 7:
        result = 'Juli';
        break;
      case 8:
        result = 'August';
        break;
      case 9:
        result = 'September';
        break;
      case 10:
        result = 'Oktober';
        break;
      case 11:
        result = 'November';
        break;
      case 12:
        result = 'Dezember';
        break;
      default:
        break;
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/month-name-pipe/month-name.pipe.ts